export default "__VITE_ASSET__aba48ba0__"